import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import Typography from './typography';
import { tuple } from '../_utils/type';
import { omit } from '../_utils/omit';
import devWarning from '../_utils/devwarning';
export var BaseTypes = tuple('second', 'success', 'warning', 'danger', 'assist');
function wrapperDecorations(_ref, content) {
  var mark = _ref.mark,
    code = _ref.code,
    underline = _ref.underline,
    del = _ref.delete,
    strong = _ref.strong,
    keyboard = _ref.keyboard,
    italic = _ref.italic;
  var currentContent = content;
  function wrap(needed, tag) {
    if (!needed) return;
    currentContent = /*#__PURE__*/React.createElement(tag, {}, currentContent);
  }
  wrap(strong, 'strong');
  wrap(underline, 'u');
  wrap(del, 'del');
  wrap(code, 'code');
  wrap(mark, 'mark');
  wrap(keyboard, 'kbd');
  wrap(italic, 'i');
  return currentContent;
}
var InternalBase = function InternalBase(props, ref) {
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps;
  var contentRef = ref || /*#__PURE__*/React.createRef();
  var typographyProps = getCompProps('Typography', userDefaultProps, props);
  var customPrefixcls = typographyProps.prefixCls;
  var typographyPrefixCls = getPrefixCls(prefixCls, 'typography', customPrefixcls); // 排版样式前缀
  var renderContent = function renderContent() {
    var _context, _classNames;
    var component = props.component,
      children = props.children,
      className = props.className,
      type = props.type,
      disabled = props.disabled,
      style = props.style,
      restProps = __rest(props, ["component", "children", "className", "type", "disabled", "style"]);
    if (type) {
      devWarning(BaseTypes.indexOf(type) === -1, 'typography', "cannot found type '".concat(type, "'"));
    }
    var textProps = omit(restProps, ['prefixCls', 'strong', 'underline', 'delete', 'code', 'mark', 'keyboard', 'italic']);
    var typographyClasses = classNames(className, (_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(typographyPrefixCls, "-")).call(_context, type), type), _defineProperty(_classNames, "".concat(typographyPrefixCls, "-disabled"), disabled), _classNames));
    var textNode = children;
    textNode = wrapperDecorations(props, textNode);
    return /*#__PURE__*/React.createElement(Typography, _extends({
      component: component,
      style: style,
      className: typographyClasses,
      ref: contentRef
    }, textProps), textNode);
  };
  return renderContent();
};
var Base = /*#__PURE__*/React.forwardRef(InternalBase);
export default Base;